import styled from 'styled-components';

export const PaywallAINumberStyles = styled.section`
  margin: 32px 0;

  .paywall-ai-number-wrapper {
    width: 193px;
    height: 56px;
    margin: 0 auto;

    img {
      width: 100%;
      height: 100%;
    }
  }
`;
